const getters = {
  panelState: (state) => state.panelState,
  userState: (state) => state.userState,
  statementProcessorEnabled: (state) => state.statementProcessorEnabled,
  accountExportEnabled: (state) => state.accountExportEnabled,
};

export default getters;
